export interface ApiErrorShape {
  error: { code: string; message: string; requestId: string };
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly requestId?: string,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' });
  if (!response.ok) {
    let error: ApiErrorShape | null = null;
    try {
      error = (await response.json()) as ApiErrorShape;
    } catch {
      // Keep a safe generic message when the upstream body is not JSON.
    }
    throw new ApiError(
      response.status,
      error?.error.code ?? 'REQUEST_FAILED',
      error?.error.message ?? 'The request could not be completed',
      error?.error.requestId,
    );
  }
  return response.status === 204 ? (undefined as T) : ((await response.json()) as T);
}

export function adminApi<T>(path: string, init: RequestInit = {}): Promise<T> {
  return api<T>(path, init);
}

export function recordFunnelEvent(event: Record<string, unknown>): Promise<void> {
  return api('/api/events', { method: 'POST', body: JSON.stringify(event) })
    .then(() => undefined)
    .catch(() => undefined);
}
